import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PurlivoAccountSwitch } from '@shared/common/session/purlivo-account-switch';
import { PurlivoBrowserContext } from '@shared/common/session/purlivo-browser-context';
import { AppAuthService } from '@app/shared/common/auth/app-auth.service';
import { AppUrlService } from '@shared/common/nav/app-url.service';
import {
    AccountServiceProxy,
    SwitchToLinkedAccountInput,
    SwitchToLinkedAccountOutput,
} from '@shared/service-proxies/service-proxies';

@Injectable()
export class LinkedAccountService {
    private _accountService = inject(AccountServiceProxy);
    private _appUrlService = inject(AppUrlService);
    private _authService = inject(AppAuthService);

    switchToAccount(userId: number, tenantId?: number): void {
        const input = new SwitchToLinkedAccountInput();
        input.targetUserId = userId;
        input.targetTenantId = tenantId;

        void PurlivoAccountSwitch.run(async () => {
            const result: SwitchToLinkedAccountOutput = await firstValueFrom(this._accountService.switchToLinkedAccount(input));
            // A delayed response cannot log out or redirect a different account that won meanwhile.
            if (!PurlivoBrowserContext.check()) return;
            let targetUrl = this._appUrlService.getAppRootUrlOfTenant(result.tenancyName) +
                '?switchAccountToken=' + result.switchAccountToken;
            if (input.targetTenantId) targetUrl += '&tenantId=' + input.targetTenantId;
            await new Promise<void>((resolve, reject) => {
                this._authService.logout(true, targetUrl, resolve, () => reject(new Error('Native logout failed.')));
            });
        }).then(status => {
            if (status === 'busy' || status === 'unsupported') {
                const key = status === 'busy' ? 'PurlivoAccountSwitchBusy' : 'PurlivoAccountSwitchUnavailable';
                abp.message.warn(abp.localization.localize(key, 'UVSAN'));
            }
        }).catch(() => abp.message.error(abp.localization.localize('AnErrorOccurred', 'UVSAN')));
    }
}
